import xior from 'xior';
import * as Config from '../config';

const TIMEOUT = 60_000;

const getBaseUrl = () => `https://mapnotes.locuslabs.com/${Config.getStage()}`;

const getHeaders = async () => ({
    'x-api-key': await Config.getAccessToken(),
    'Content-Type': 'application/json',
});

const MapNotes = {
    getMapNotelets: async venueId => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.get(`${getBaseUrl()}/v1/accounts/${accountId}/venues/${venueId}/mapnotes`, {
                headers,
                timeout: TIMEOUT,
            });
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in getMapNotelets', err.message || err);
        }
    },

    getMapNoteTotals: async venueId => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.get(`${getBaseUrl()}/v1/accounts/${accountId}/mapnote/summary`, {
                headers,
                params: { venueId },
                timeout: TIMEOUT,
            });
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in getMapNoteTotals', err.message || err);
        }
    },

    getSelectedMapNote: async (venueId, noteId) => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.get(`${getBaseUrl()}/v1/accounts/${accountId}/venues/${venueId}/mapnote/${noteId}`, {
                headers,
                timeout: TIMEOUT,
            });
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in getSelectedMapNote', err.message || err);
        }
    },

    deleteMapNote: async (venueId, noteId, email) => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.delete(
                `${getBaseUrl()}/v1/accounts/${accountId}/venues/${venueId}/email/${email}/mapnote/${noteId}`,
                { headers, timeout: TIMEOUT },
            );
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in deleteMapNote', err.message || err);
        }
    },

    updateMapNote: async (venueId, noteId, changes) => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.patch(
                `${getBaseUrl()}/v1/accounts/${accountId}/venues/${venueId}/mapnote/${noteId}`,
                changes,
                { headers, timeout: TIMEOUT },
            );
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in updateMapNote', err.message || err);
        }
    },

    addMapNoteComment: async (venueId, email, noteId, comment) => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.post(
                `${getBaseUrl()}/v1/accounts/${accountId}/venues/${venueId}/email/${email}/mapnote/${noteId}`,
                comment,
                { headers, timeout: TIMEOUT },
            );
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in addMapNoteComment', err.message || err);
        }
    },

    createMapNote: async (venueId, email, newNote) => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.post(
                `${getBaseUrl()}/v1/accounts/${accountId}/venues/${venueId}/email/${email}/mapnote`,
                newNote,
                { headers, timeout: TIMEOUT },
            );
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in createMapNote', err.message || err);
        }
    },

    deleteMapNoteComment: async (venueId, email, noteId, commentId) => {
        try {
            const accountId = Config.getAccountId();
            const headers = await getHeaders();
            const res = await xior.delete(
                `${getBaseUrl()}/v1/accounts/${accountId}/venues/${venueId}/email/${email}/mapnote/${noteId}/comment/${commentId}`,
                { headers, timeout: TIMEOUT },
            );
            return res.data.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error in deleteMapNoteComment', err.message || err);
        }
    },
};

export { MapNotes };
